export default __webpack_public_path__ + "static/media/family-road-trip.d9d940c8.jpg";